import { FunctionComponent } from "react";

import {
  FieldItem,
  Option,
  OptionsSelect,
  OptionsSelectProps,
  useFieldRegister,
  useFieldContext,
  getFieldErrorMessage,
  useFormSubscription
} from "@bps/fluent-ui";
import { SalesProductDto } from "@libs/api/gateways/plt/plt-gateway.dtos";
import { useSalesProducts } from "@libs/api/gateways/plt/plt-gateway.hooks";

export type FormLicenceTypesSelectProps = Omit<
  OptionsSelectProps,
  "options" | "selectedKeys" | "onChangeSelectedKeys" | "label"
> & { licenceTypeCode: string | undefined; name: string; label?: string };

export const FormProductTypesSelect: FunctionComponent<FormLicenceTypesSelectProps> = ({
  name,
  licenceTypeCode,
  label,
  ...rest
}) => {
  useFieldRegister(name);
  const { value, setFieldValue, meta } = useFieldContext<
    string | string[] | undefined
  >(name);

  const {
    state: { triedToSubmit }
  } = useFormSubscription({ subscriptions: { triedToSubmit: true } });

  const {
    isLoading: isLoadingProducts,
    error: errorProducts,
    data: dataProducts = []
  } = useSalesProducts({
    licenceTypeCodes: licenceTypeCode ? [licenceTypeCode] : undefined,
    isInactive: false // Only active products should be returned
  });

  const options: Option<SalesProductDto>[] = dataProducts.map(data => ({
    key: data?.id ?? "",
    text: data.name ?? "",
    data
  }));

  return (
    <FieldItem
      label={label}
      name={name}
      errorMessage={
        meta
          ? getFieldErrorMessage(meta, {
              triedToSubmit
            })
          : undefined
      }
    >
      <OptionsSelect
        options={options}
        selectedKeys={value}
        onChangeSelectedKeys={setFieldValue}
        errorMessage={errorProducts?.message}
        loading={isLoadingProducts}
        {...rest}
      />
    </FieldItem>
  );
};
